/** @typedef	{import('./Props').default} Props */
/** @typedef {import('../../../App/shared/SubscriptionService/Subscription').default} Subscription */

import React from 'react';
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard';
import PremiumSubscriptionCard from '../SubscriptionCard/PremiumSubscriptionCard';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionPlans(props) {
	const [subscription, setSubscription] = React.useState(props?.subscription);
	const [lastPlanChange, setLastPlanChange] = React.useState(
		/** @type {{status: 'upgraded' | 'downgraded', targetTier: number} | null} */ (
			null
		)
	);

	React.useEffect(() => {
		setSubscription(props?.subscription);
		setLastPlanChange(null);
	}, [props?.subscription]);

	/**
	 * @param {{
	 * 	targetTier: number,
	 * 	status: 'upgraded' | 'downgraded',
	 * 	priceInCents: number,
	 * 	scheduledChange?: Subscription['scheduledChange'],
	 * }} change
	 * @returns {void}
	 */
	function handlePlanChange(change) {
		setLastPlanChange({
			status: change.status,
			targetTier: change.targetTier,
		});

		setSubscription((previousSubscription) => {
			if (!previousSubscription) {
				return previousSubscription;
			}

			return {
				...previousSubscription,
				isActive:
					change.status === 'upgraded'
						? change.priceInCents > 0
						: previousSubscription.isActive,
				priceInCents:
					change.status === 'upgraded'
						? change.priceInCents
						: previousSubscription.priceInCents,
				scheduledChange:
					change.status === 'downgraded'
						? change.scheduledChange ??
						  previousSubscription.scheduledChange
						: null,
			};
		});
	}

	const currentTierValue =
		subscription?.isActive === true
			? props.tiers.find(
					(tier) => tier.pricePerMonth === subscription.priceInCents
			  )?.tier ?? 0
			: 0;
	const effectiveTierValue =
		props.checkoutRole === 'agent'
			? Math.max(currentTierValue, props.groupTierFloor ?? 0)
			: currentTierValue;

	return (
		<section className="flex flex-col gap-4 lg:grid lg:grid-cols-3 ">
			{props?.tiers?.map((tier) => {
				if (
					tier.title === 'enterprise' ||
					tier.title === 'professional'
				) {
					return (
						<PremiumSubscriptionCard
							checkoutRole={props?.checkoutRole}
							currentTierValue={currentTierValue}
							effectiveTierValue={effectiveTierValue}
							groupTierFloor={props?.groupTierFloor}
							groupId={props?.groupId}
							hasExistingSubscription={
								props?.hasExistingSubscription
							}
							isGettingData={props?.isGettingData}
							key={tier.title}
							lastPlanChange={lastPlanChange}
							onPlanChanged={handlePlanChange}
							paymentLinks={props?.paymentLinks}
							subscription={subscription}
							tier={tier}
						/>
					);
				}

				return (
					<SubscriptionCard
						checkoutRole={props?.checkoutRole}
						currentTierValue={currentTierValue}
						effectiveTierValue={effectiveTierValue}
						groupTierFloor={props?.groupTierFloor}
						groupId={props?.groupId}
						hasExistingSubscription={props?.hasExistingSubscription}
						isGettingData={props?.isGettingData}
						key={tier.title}
						lastPlanChange={lastPlanChange}
						onPlanChanged={handlePlanChange}
						paymentLinks={props?.paymentLinks}
						subscription={subscription}
						tier={tier}
					/>
				);
			})}
		</section>
	);
}

export default React.memo(SubscriptionPlans);
